module.exports = __webpack_public_path__ + "static/media/eu-aluekehitys-color.600ae7d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/eu-aluekehitys-color.svg
// module id = 134
// module chunks = 0